var _ellipse, _ellipse2, _ellipse3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHappy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 102,
    viewBox: "0 0 101 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.7551,
    cy: 50.9886,
    rx: 47.7551,
    ry: 47.8548,
    stroke: "#00AE4E",
    strokeWidth: 4.79725
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.4178,
    cy: 38.3953,
    rx: 5.02685,
    ry: 5.03735,
    fill: "#00AE4E"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.579,
    cy: 38.3953,
    rx: 5.02685,
    ry: 5.03735,
    fill: "#00AE4E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0193 61.0632C30.0193 61.0632 37.5596 73.0268 50.7551 73.0269C62.9726 73.0269 69.6058 61.0632 69.6058 61.0632",
    stroke: "#00AE4E",
    strokeWidth: 4.79725,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappy);
export default __webpack_public_path__ + "static/media/happy.8a7498153bc8a2c311e39ea7a47908d2.svg";
export { ForwardRef as ReactComponent };